import { useState } from 'react';

/**
 * True from the first render where `when` is true, and from then on: for a
 * lazily loaded dialog that should stay mounted after it first opens, so it
 * can close (and restore focus) as it always did.
 */
export function useMountedOnce(when: boolean): boolean {
  const [mounted, setMounted] = useState(when);
  if (when && !mounted) setMounted(true);
  return mounted || when;
}
